export default {
    name: 'determinantTypes',
    serverName: '/api/v1/determinant/determinant/',
    apiUrl: '/api/v1/determinant/determinant/active/'
};
